import React from 'react';
import {
    HomeOutlined,
    ContactsOutlined,
    TeamOutlined,
    GoldOutlined,
    ProjectOutlined,
    TransactionOutlined,
    EnvironmentOutlined,
    MoneyCollectOutlined,
    AuditOutlined,
    LineChartOutlined,
    DesktopOutlined,
    GlobalOutlined,
    PayCircleOutlined,
    MobileOutlined,
    UnorderedListOutlined
} from '@ant-design/icons';

import { ROLES } from "../../../utils/constant";

const {
    ADMIN,
    SELLER,
    CTO,
    SERVICEADMIN,
    FINANCE,
    PRESELLER,
    HRBP,
    BUSINESS,
    HRBP_ASSISTANT,
    CRMADMIN,
    CLOCK,
    TECHNOLOGY,
    LAW,
    WEAPON,
    PRODUCT,
    SERVICE,
    OPERATING,
    OTHER_WEAPON,
    WIN_APPLYER,
    RETURN_ADMIN,
    RETURN_ADMIN_NO_CONTRACT,
    INVOICE_SERVICE,
    INVOICE_ENTER,
    DEPARTMENT_ADMIN,
    SUPERVISE,
    PRESELLER_ADMIN,
    COST_CHANNEL_ADMIN,
} = ROLES;

const menuList = (memory) => {
    return [
        {
            title: "首页",
            key: "/crm",
            icon: <HomeOutlined />,
        },
        {
            title: "客户公海",
            key: "/crm/client/list",
            icon: <ContactsOutlined />,
            role: [CRMADMIN, SELLER, CLOCK, PRESELLER, HRBP, HRBP_ASSISTANT, RETURN_ADMIN, RETURN_ADMIN_NO_CONTRACT, ROLES.PROJECT_ADMIN],
        },
        {
            title: "KP管理",
            key: "/crm/client/kp/list",
            icon: <TeamOutlined />,
            role: [SELLER, BUSINESS, ROLES.MANAGER, ROLES.INVOICE_ENTER],
        },
        {
            title: "商机列表",
            key: "/crm/commercial_opportunity/list",
            icon: <GoldOutlined />,
        },
        {
            title: "项目列表",
            key: "/crm/admin/business/list",
            icon: <ProjectOutlined />,
        },
        {
            title: "回款管理",
            key: "/crm/admin/returned-apply/list",
            icon: <TransactionOutlined />,
        },
        {
            title: "客户信息",
            key: "/crm/client/detail",
            icon: "smill",
            hide: true,
        },
        {
            title: "修改客户信息",
            key: "/crm/client/edit",
            icon: "smill",
            hide: true,
        },
        {
            title: "添加KP",
            key: "/crm/client/kpadd",
            icon: "smill",
            hide: true,
        },
        {
            title: "KP信息",
            key: "/crm/client/kpdetail",
            icon: "smill",
            hide: true,
        },
        {
            title: "修改KP信息",
            key: "/crm/client/kpedit",
            icon: "smill",
            hide: true,
        },
        {
            title: "添加项目",
            key: "/crm/client/business-add",
            icon: "smill",
            hide: true,
        },
        {
            title: "项目信息",
            key: "/crm/client/business-detail",
            icon: "smill",
            hide: true,
        },
        {
            title: "修改项目",
            key: "/crm/client/business-edit",
            icon: "smill",
            hide: true,
        },
        {
            title: "合同申请",
            key: "/crm/client/contract-add",
            icon: "smill",
            hide: true,
        },
        {
            title: "修改合同信息",
            key: "/crm/client/contract-edit",
            icon: "smill",
            hide: true,
        },
        /* {
            title: "考勤统计",
            key: "/crm/attendance",
            icon: <EnvironmentOutlined />,
        }, */
        {
            title: "薪资结算",
            key: "/crm/compensation",
            icon: <MoneyCollectOutlined />,
            role: [ADMIN, HRBP, HRBP_ASSISTANT, RETURN_ADMIN, RETURN_ADMIN_NO_CONTRACT, ROLES.ROYALTY],
        },
        {
            title: '审批中心',
            key: "/crm/applyCenter",
            icon: <AuditOutlined />,
            children: [
                {
                    title: '项目经理申请',
                    key: '/crm/salesman/my-preseller/list',
                    icon: 'table',
                    role: [CRMADMIN, SELLER],
                },
                {
                    title: "报价单申请",
                    key: "/crm/salesman/quotation/list",
                    icon: "table",
                    role: [CRMADMIN, SELLER],//ROLES.PRESELLER
                },
                {
                    title: "合同申请",
                    key: "/crm/salesman/my-contract/list",
                    icon: "table",
                    role: [CRMADMIN, SELLER],
                },
                {
                    title: "毛利核算",
                    key: "/crm/salesman/my-cost/list",
                    icon: "table",
                    role: [CRMADMIN, SELLER],
                },

                {
                    title: "发票申请",
                    key: "/crm/salesman/my-invoice/list",
                    icon: "table",
                    role: [CRMADMIN, SELLER],
                },

                {
                    title: "费用申请",
                    key: "/crm/salesman/my-marketCost/list",
                    icon: "table",
                    role: [CRMADMIN, SELLER],
                },
                {
                    title: "外出申请",
                    key: "/crm/salesman/my-go-out/list",
                    icon: "table",
                    role: [SELLER],
                },
                {
                    title: "合同附件申请",
                    key: "/crm/my/contract-file-apply/list",
                    icon: "contacts",
                },
                {
                    title: "日报批阅",
                    key: "/crm/approve/work-log-apply/list",
                    icon: "edit",
                    count: {
                        type: "daily",
                        api: [],
                        params: [{
                            examined: false,
                            is_pm: false,
                            count_only: true,
                        }],
                    },
                    role: [
                        ROLES.CAPTAIN,
                        ROLES.MANAGER,
                        HRBP,
                        ROLES.DEPARTMENT_ADMIN,
                        ROLES.RIRECTOR,
                        PRESELLER_ADMIN,
                        ROLES.PREADMIN,
                    ],
                },
                {
                    title: "毛利核算",
                    key: "/crm/approve/cost-apply/list",
                    icon: "edit",
                    count: {
                        type: "cost",
                        api: [],
                        params: [{
                            type: 9,
                            is_history: false,
                            count_only: true,
                        }],
                    },
                    role: [
                        BUSINESS,
                        PRODUCT,
                        SERVICE,
                        OPERATING,
                        DEPARTMENT_ADMIN,
                        COST_CHANNEL_ADMIN,
                        ROLES.COST_FINAL_ADMIN,
                        ROLES.FINANCE,
                        ROLES.WEAPON_BUSINESS,
                        HRBP,
                        CTO,
                        ROLES.RIRECTOR,
                        PRESELLER
                    ],
                },
                {
                    title: "出门卡审批(助理)",
                    key: "/crm/approve/go-out-apply/list",
                    icon: "edit",
                    count: {
                        type: "assistantGoOut",
                        api: [],
                        params: [{
                            is_history: false,
                            count_only: true,
                        }],
                    },
                    role: [ROLES.DEPARTMENT_ADMIN, ROLES.CEO],
                },
                {
                    title: "出门卡审批(销售)",
                    key: "/crm/approve/go-out-apply/list/seller",
                    icon: "edit",
                    count: {
                        type: "sellerGoOut",
                        api: [],
                        params: [{
                            is_history: false,
                            count_only: true,
                        }],
                    },
                    role: [ROLES.DEPARTMENT_ADMIN, ROLES.SPECIAL_APPROVER, ROLES.BUSINESS, ROLES.RIRECTOR, ROLES.GO_OUT_APPROVE],
                },
                {
                    title: "合同文件审批",
                    key: "/crm/approve/contract-file-apply/list",
                    icon: "edit",
                    count: {
                        type: "contract-file",
                        api: [],
                        params: [{
                            examined: false,
                            count_only: true,
                        }],
                    },
                    role: [ROLES.CONTRACT_APPROVE],
                },
                {
                    title: "退跟审批",
                    key: "/crm/approve/seller-admin-apply/list",
                    icon: "edit",
                    count: {
                        type: "abandon",
                        api: [],
                        params: [{
                            is_history: false,
                            type: 1,
                            count_only: true,
                        }],
                    },
                    role: [BUSINESS, HRBP, ROLES.RIRECTOR],//ADMIN, CRMADMIN,
                },
                {
                    title: "赢单审批",
                    key: "/crm/approve/win-apply/list",
                    icon: "edit",
                    count: {
                        type: "winApply",
                        api: [],
                        params: [{
                            is_history: false,
                            type: 6,
                            count_only: true,
                        }],
                    },
                    role: [WIN_APPLYER, HRBP],//ADMIN, CRMADMIN,
                },
                {
                    title: "合同项目经理审批",
                    key: "/crm/approve/pm-approve/list",
                    icon: "edit",
                    count: {
                        type: "contractPM",
                        api: [],
                        params: [{
                            type: 8,
                            stage: 1,
                            count_only: true,
                            is_history: false,
                        }],
                    },
                    role: [PRESELLER],//ADMIN, CRMADMIN,
                },
                {
                    title: "合同交付部门审批",
                    key: "/crm/approve/technology-approve/list",
                    icon: "edit",
                    count: {
                        type: "contractTech",
                        api: [],
                        params: [{
                            type: 8,
                            stage: 2,
                            count_only: true,
                            is_history: false,
                        }],
                    },
                    role: [
                        TECHNOLOGY,
                        PRODUCT,
                        SERVICE,
                        OPERATING,
                        OTHER_WEAPON,
                        ROLES.WEAPON_BUSINESS,
                    ],
                },
                {
                    title: "合同法务审批",
                    key: "/crm/approve/law-approve/list",
                    icon: "edit",
                    count: {
                        type: "contractfinace",
                        api: [],
                        params: [{
                            type: 8,
                            stage: 3,
                            count_only: true,
                            is_history: false,
                        }],
                    },
                    role: [LAW],
                },
                {
                    title: "发票财务审批",
                    key: "/crm/approve/invoice-finance/list",
                    icon: "edit",
                    count: {
                        type: "invoiceFinace",
                        api: [],
                        params: [{
                            type: 10,
                            stage: 3,
                            count_only: true,
                            is_history: false,
                        }],
                    },
                    role: [RETURN_ADMIN, RETURN_ADMIN_NO_CONTRACT],
                },
                {
                    title: "发票信息录入",
                    key: "/crm/approve/invoice-enter/list",
                    icon: "edit",
                    count: {
                        type: "invoiceMessage",
                        api: [],
                        params: [{
                            type: 10,
                            stage: 4,
                            count_only: true,
                            is_history: false,
                        }],
                    },
                    role: [INVOICE_ENTER, ROLES.INVOICE_CC],
                },
                {
                    title: "费用财务审批",
                    key: "/crm/approve/marketCost-finance/list",
                    icon: "edit",
                    count: {
                        type: "marketFinance",
                        api: [],
                        params: [{
                            stage: 3,
                            count_only: true,
                            is_history: false,
                        }],
                    },
                    role: [ROLES.MARKET_FINANCE],
                },
                {
                    title: "费用最终确认",
                    key: "/crm/approve/marketCost-final/list",
                    icon: "edit",
                    count: {
                        type: "marketFinal",
                        api: [],
                        params: [{
                            stage: 4,
                            count_only: true,
                            is_history: false,
                        }],
                    },
                    role: [ROLES.MARKETCOST_FINAL],//ADMIN,
                },
                {
                    title: "报价单审批",
                    key: "/crm/approve/quotation/list",
                    icon: "edit",
                    count: {
                        type: "quotation",
                        api: [],
                        params: [{
                            count_only: true,
                            examined: false,
                        }],
                    },
                    role: [ROLES.QUOTATION_APPROVER, ROLES.RIRECTOR],
                },
                {
                    title: "输单审批",
                    key: "/crm/approve/loseApplication/list",
                    icon: "edit",

                    role: [ROLES.DEPARTMENT_ADMIN, ROLES.RIRECTOR],
                },

                {
                    title: "打卡审批(管理员)",
                    key: "/crm/approve/work-log-check/list",
                    icon: "edit",
                    role: [ROLES.SPECIAL_APPROVER],
                },
                {
                    title: "打卡审批",
                    key: "/crm/approve/work-log-check-manager/list",
                    icon: "edit",
                    role: [ROLES.DEPARTMENT_ADMIN, HRBP, ROLES.WORK_LOG_APPROVER],//ADMIN, 
                },
            ]
        },
        {
            title: '统计中心',
            key: '/crm/statistics-center',
            icon: <LineChartOutlined />,
            role: [ADMIN, ROLES.RIRECTOR],
            children: [
                {
                    title: '经营分析中心',
                    key: '/crm/statistics-center',
                    icon: <UnorderedListOutlined />,
                    role: [ADMIN, ROLES.RIRECTOR],
                },
            ]
        },
        {
            title: "我的工作",
            key: "/crm/salesman",
            icon: <DesktopOutlined />,
            role: [CRMADMIN, SELLER, CLOCK],
            children: [
                {
                    title: "我的客户",
                    key: "/crm/salesman/list",
                    icon: <UnorderedListOutlined />,
                    role: [CRMADMIN, SELLER],
                },

                {
                    title: "我的外出申请",
                    key: "/crm/salesman/my-go-out/detail",
                    hide: true
                },
                {
                    title: "我的打卡",
                    key: "/crm/salesman/my-log",
                    icon: <UnorderedListOutlined />,
                },


                {
                    title: "日志详情",
                    key: "/crm/salesman/log-detail",
                    icon: "smill",
                    hide: true,
                },
                {
                    title: "编辑工作日志",
                    key: "/crm/salesman/log-edit",
                    icon: "smill",
                    hide: true,
                },
                {
                    title: "工作日报",
                    key: "/crm/salesman/daily-log",
                    icon: <UnorderedListOutlined />,
                },

                {
                    title: "武器库列表",
                    key: "/crm/salesman/weapon/list",
                    icon: <UnorderedListOutlined />,
                    role: [ADMIN, CRMADMIN, SELLER],
                },
            ],
        },
        {
            title: "审批管理",
            key: "/crm/approve",
            icon: "desktop",
            role: [
                ADMIN,
                CRMADMIN,
                BUSINESS,
                SERVICEADMIN,
                CTO,
                HRBP,
                TECHNOLOGY,
                LAW,
                PRODUCT,
                PRESELLER,
                SERVICE,
                OPERATING,
                OTHER_WEAPON,
                WIN_APPLYER,
                RETURN_ADMIN,
                RETURN_ADMIN_NO_CONTRACT,
                INVOICE_SERVICE,
                INVOICE_ENTER,
                DEPARTMENT_ADMIN,
                PRESELLER_ADMIN,
                COST_CHANNEL_ADMIN,
                ROLES.COST_FINAL_ADMIN,
                ROLES.FINANCE,
                ROLES.MARKET_ADMIN,
                ROLES.MARKET_BUSINESS,
                ROLES.MARKET_FINANCE,
                ROLES.INVOICE_CC,
                ROLES.JACK_PROJECT,
                ROLES.WEAPON_BUSINESS,
                ROLES.SPECIAL_APPROVER,
                ROLES.MARKETCOST_FINAL,
                ROLES.PM_DAILYWORK_APPROVER,
                ROLES.RIRECTOR,
                ROLES.PREADMIN,
                ROLES.QUOTATION_APPROVER,
                ROLES.CAPTAIN,
                ROLES.RIRECTOR
            ],
            //抵冲hide在applyCenter内被隐藏
            hide: true,
            applyCenter: true,
            children: [

                {
                    title: "日报批阅",
                    key: "/crm/approve/work-log-apply/detail",
                    icon: "edit",
                    hide: true,
                },

                {
                    title: "毛利核算",
                    key: "/crm/approve/cost-apply/detail",
                    icon: "edit",
                    hide: true,
                },

                {
                    title: "退跟/跟进审批",
                    key: "/crm/approve/seller-admin-apply/detail",
                    icon: "edit",
                    hide: true,
                },

                {
                    title: "赢单审批",
                    key: "/crm/approve/win-apply/detail",
                    icon: "edit",
                    hide: true,
                },

                {
                    title: "合同交付部门审批",
                    key: "/crm/approve/technology-approve/detail",
                    icon: "edit",
                    hide: true,
                },

                {
                    title: "合同法务审批",
                    key: "/crm/approve/law-approve/detail",
                    icon: "edit",
                    hide: true,
                },
                {
                    title: "发票总监审批",
                    key: "/crm/approve/invoice-business/detail",
                    icon: "edit",
                    hide: true,
                },
                {
                    title: "发票总监审批",
                    key: "/crm/approve/invoice-business/history",
                    icon: "edit",
                    hide: true,
                },
                {
                    title: "发票安服审批",
                    key: "/crm/approve/invoice-service/detail",
                    icon: "edit",
                    hide: true,
                },
                {
                    title: "发票安服审批",
                    key: "/crm/approve/invoice-service/history",
                    icon: "edit",
                    hide: true,
                },

                {
                    title: "发票财务审批",
                    key: "/crm/approve/invoice-finance/detail",
                    icon: "edit",
                    hide: true,
                },
                {
                    title: "发票财务审批",
                    key: "/crm/approve/invoice-finance/history",
                    icon: "edit",
                    hide: true,
                },

                {
                    title: "发票信息录入",
                    key: "/crm/approve/invoice-enter/detail",
                    icon: "edit",
                    hide: true,
                },
                {
                    title: "发票信息录入",
                    key: "/crm/approve/invoice-enter/history",
                    icon: "edit",
                    hide: true,
                },

                {
                    title: "输单审批历史记录",
                    key: '/crm/approve/loseApplication/history',
                    icon: "edit",
                    role: [ROLES.DEPARTMENT_ADMIN, ROLES.RIRECTOR],
                    hide: true
                },
            ],
        },
        {
            title: "我是管理",
            key: "/crm/admin",
            icon: <GlobalOutlined />,
            role: [
                ADMIN,
                FINANCE,
                HRBP,
                BUSINESS,
                HRBP_ASSISTANT,
                CRMADMIN,
                WEAPON,
                PRODUCT,
                SERVICE,
                OPERATING,
                OTHER_WEAPON,
                RETURN_ADMIN,
                RETURN_ADMIN_NO_CONTRACT,
                LAW,
                SUPERVISE,
                PRESELLER_ADMIN,
                INVOICE_ENTER,
                ROLES.MARKET_CC,
                ROLES.DAILY_WORK_VIEWER,
                ROLES.WEAPON_BUSINESS,
                ROLES.SPECIAL_APPROVER,
                ROLES.GO_OUT_APPROVE,
                ROLES.CONTRACTADMIN,
                ROLES.MANAGER,
                ROLES.PROJECT_FINISHED,
                ROLES.EQUIPMENT,
                ROLES.PREADMIN,
                ROLES.ASSISTANT,
                ROLES.RIRECTOR
            ],
            children: [
                {
                    title: "人员管理",
                    key: "/crm/admin/memberControl",
                    icon: <UnorderedListOutlined />,
                    role: [ADMIN, CRMADMIN, HRBP, BUSINESS, FINANCE, ROLES.EQUIPMENT, ROLES.RIRECTOR, HRBP_ASSISTANT],
                },
                {
                    title: '考勤管理',
                    key: '/crm/admin/workControl',
                    icon: <UnorderedListOutlined />,
                    role: [
                        ROLES.SPECIAL_APPROVER,
                        ROLES.CLCLE,
                        ADMIN,
                        CRMADMIN,
                        HRBP,
                        HRBP_ASSISTANT,
                        BUSINESS,
                        PRODUCT,
                        SERVICE,
                        OPERATING,
                        OTHER_WEAPON,
                        ROLES.WEAPON_BUSINESS,
                        RETURN_ADMIN,
                        PRESELLER_ADMIN,
                        ROLES.MANAGER,
                        ROLES.PREADMIN,
                        ROLES.DEPARTMENT_ADMIN,
                        ROLES.ASSISTANT
                    ],
                },
                {
                    title: '合同与款项',
                    key: "/crm/admin/contractControl",
                    icon: <UnorderedListOutlined />,
                    role: [ADMIN, CRMADMIN, RETURN_ADMIN, RETURN_ADMIN_NO_CONTRACT, LAW, FINANCE, SUPERVISE, ROLES.MARKET_CC],
                },
                {
                    title: "合同申请列表",
                    key: "/crm/admin/contract/apply/detail",
                    hide: true,
                },
                {
                    title: "添加人员",
                    key: "/crm/admin/salesman/add",
                    hide: true,
                },
                {
                    title: "人员详情",
                    key: "/crm/admin/salesman/detail",
                    hide: true,
                },
                {
                    title: "设置配额",
                    key: "/crm/admin/salesman/edit",
                    hide: true,
                },
                {
                    title: "设置目标",
                    key: "/crm/admin/salesman/target",
                    hide: true,
                },
                {
                    title: "销售业绩",
                    key: "/crm/admin/salesman/target",
                    icon: <UnorderedListOutlined />,
                    role: [ADMIN, ROLES.MANAGER, ROLES.RIRECTOR, ROLES.HRBP],
                },
                {
                    title: "客户标签",
                    key: "/crm/client-tag/list",
                    icon: <UnorderedListOutlined />,
                    role: [ROLES.MANAGER],
                },
                {
                    title: "发票列表",
                    key: "/crm/admin/invoice/already/list",
                    hide: true,
                },
                {
                    title: "发票列表",
                    key: "/crm/admin/invoice/pending/list",
                    hide: true,
                },
                {
                    title: "回款列表",
                    key: "/crm/admin/return/unbind/list",
                    hide: true,
                },
                {
                    title: "回款管理",
                    key: "/crm/admin/returned-apply/detail",
                    hide: true,
                },
                {
                    title: "武器库管理",
                    key: "/crm/admin/weapon/list",
                    icon: <UnorderedListOutlined />,
                    role: [ADMIN, CRMADMIN, WEAPON],
                },
                {
                    title: "数据映射管理",
                    key: "/crm/admin/data-mapping",
                    icon: <UnorderedListOutlined />,
                    role: [ADMIN, CRMADMIN],
                },
                {
                    title: "项目提成历史列表",
                    key: "/crm/admin/commission/history",
                    hide: true,
                },
                {
                    title: "项目提成详情",
                    key: "/crm/admin/commission/detail",
                    hide: true,
                },
            ],
        },
        {
            title: "财务工作",
            key: "/crm/finance",
            icon: <PayCircleOutlined />,
            role: [ROLES.RETURN_ADMIN, ROLES.RETURN_ADMIN_NO_CONTRACT, ROLES.MANAGER, ROLES.VENDOR_ADMIN],
            children: [
                {
                    title: "应付账款",
                    key: "/crm/finance/disbursement/list",
                    icon: <UnorderedListOutlined />,
                    role: [ROLES.RETURN_ADMIN, ROLES.RETURN_ADMIN_NO_CONTRACT, ROLES.CRMADMIN, ROLES.MANAGER],
                },
                {
                    title: "付款发票列表",
                    key: "/crm/finance/invoice/list",
                    icon: <UnorderedListOutlined />,
                    role: [ROLES.RETURN_ADMIN, ROLES.RETURN_ADMIN_NO_CONTRACT, ROLES.CRMADMIN, ROLES.MANAGER],
                },
                {
                    title: "供应商管理",
                    key: "/crm/finance/vendor/list",
                    icon: <UnorderedListOutlined />,
                    role: [ROLES.RETURN_ADMIN, ROLES.RETURN_ADMIN_NO_CONTRACT, ROLES.CRMADMIN, ROLES.MANAGER, ROLES.VENDOR_ADMIN],
                },
            ]
        },
        {
            title: "设备管理",
            key: "/crm/equipment",
            icon: <MobileOutlined />,
            role: [ROLES.EQUIPMENT],
            children: [
                {
                    title: "设备列表",
                    key: "/crm/equipment/list",
                    icon: <UnorderedListOutlined />,
                },
            ]
        },
    ]
};

export default menuList;
